<template>
  <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
    <div class="w-full mb-2">*{{ tr('suggested_hotels_text') }}</div>
    <div class="w-full flex flex-row">
      <div class="basis-2/3">
        <textarea
          :value="modelValue"
          :disabled="disabled"
          :readonly="disabled"
          rows="4"
          class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block p-3 w-full"
          @input="$emit('update:modelValue', $event.target.value)"
        ></textarea>
      </div>
      <div class="basis-1/3 flex justify-center items-center">
        <a
          class="justify-self-center font-light border border-dark bg-white text-md py-2 px-4 hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
          @click="$emit('view-hotels')"
        >
          <template v-if="lang !== 'DE'">
            {{ tr('View') }} <template v-if="!hidePrices">{{ category }}</template> {{ tr('Hotels') }}
          </template>
          <template v-else>
            <template v-if="!hidePrices">{{ category }}</template> Hotels sehen
          </template>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingFormHotelPreferences',
  props: {
    modelValue: { type: String, default: '' },
    disabled: Boolean,
    lang: { type: String, default: '' },
    category: { type: String, default: '' },
    hidePrices: Boolean
  },
  emits: ['update:modelValue', 'view-hotels'],
  methods: {
    tr (key) {
      return this.$root.tr(key);
    }
  }
};
</script>
